export default "__VITE_ASSET__UPE2zofM__"